import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-218889c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "trust-data-external-examiner" }
const _hoisted_2 = { class: "section-heading" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Maintain trust data", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "External Examiner", -1))
const _hoisted_5 = { class: "search" }
const _hoisted_6 = { class: "search-inputs" }
const _hoisted_7 = { class: "search-bar" }
const _hoisted_8 = { class: "icon-hm" }
const _hoisted_9 = {
  key: 0,
  class: "fal fa-spinner fa-spin fa-lg"
}
const _hoisted_10 = {
  key: 1,
  class: "fal fa-search fa-lg"
}
const _hoisted_11 = ["disabled"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "space-filler",
  style: {"flex-grow":"1"}
}, null, -1))
const _hoisted_13 = { class: "table-section" }
const _hoisted_14 = { class: "ls-table" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "text" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-angle-up" }, null, -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = { key: 0 }
const _hoisted_20 = ["colspan"]
const _hoisted_21 = { key: 1 }
const _hoisted_22 = ["colspan"]
const _hoisted_23 = { key: 2 }
const _hoisted_24 = ["colspan"]
const _hoisted_25 = { key: 3 }
const _hoisted_26 = ["colspan"]
const _hoisted_27 = { "data-label": "LawID" }
const _hoisted_28 = { "data-label": "Email" }
const _hoisted_29 = { "data-label": "Last Name" }
const _hoisted_30 = { "data-label": "First Name" }
const _hoisted_31 = { "data-label": "Actions" }
const _hoisted_32 = ["onClick"]

export function render(_ctx, _cache) {
  const _component_LoadingIndicator = _resolveComponent("LoadingIndicator")
  const _component_ErrorIndicator = _resolveComponent("ErrorIndicator")
  const _component_AddEeModal = _resolveComponent("AddEeModal")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              placeholder: "Enter LawID or name",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.searchText) = $event))
            }, null, 512), [
              [_vModelText, _ctx.searchText]
            ]),
            _createElementVNode("span", _hoisted_8, [
              (_ctx.loadingContent)
                ? (_openBlock(), _createElementBlock("i", _hoisted_9))
                : (_openBlock(), _createElementBlock("i", _hoisted_10))
            ])
          ]),
          _createElementVNode("button", {
            class: "search-btn btn btn-secondary sml",
            onClick: _cache[1] || (_cache[1] = $event => (_ctx.searchEE())),
            disabled: _ctx.loadingContent
          }, " Search ", 8, _hoisted_11),
          _hoisted_12,
          _createElementVNode("button", {
            class: "btn btn-primary mr-2",
            onClick: _cache[2] || (_cache[2] = $event => (_ctx.showAddEEModal = true))
          }, "Add External examiner")
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("table", _hoisted_14, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHeadings, (h, index) => {
              return (_openBlock(), _createElementBlock("th", {
                class: _normalizeClass([ h.sortable ? 'sortable' : '']),
                onClick: $event => (_ctx.sortTableColumn(index, h.sortable))
              }, [
                _createElementVNode("div", null, [
                  _createElementVNode("span", _hoisted_16, _toDisplayString(h.text), 1),
                  (h.sortable)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: _normalizeClass([ _ctx.activeSortHeader === index ? 'active' : '', h.sortMethod])
                      }, _hoisted_18, 2))
                    : _createCommentVNode("", true)
                ])
              ], 10, _hoisted_15))
            }), 256))
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_ctx.firstLoad)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_19, [
                _createElementVNode("td", {
                  colspan: _ctx.tableHeadings.length
                }, "Please search for a record", 8, _hoisted_20)
              ]))
            : (_ctx.loadingContent)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_21, [
                  _createElementVNode("td", {
                    colspan: _ctx.tableHeadings.length
                  }, [
                    _createVNode(_component_LoadingIndicator)
                  ], 8, _hoisted_22)
                ]))
              : (_ctx.errorLoadingContent)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_23, [
                    _createElementVNode("td", {
                      colspan: _ctx.tableHeadings.length
                    }, [
                      _createVNode(_component_ErrorIndicator)
                    ], 8, _hoisted_24)
                  ]))
                : (!_ctx.loadingContent && !_ctx.errorLoadingContent && _ctx.eeList.length == 0)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_25, [
                      _createElementVNode("td", {
                        colspan: _ctx.tableHeadings.length
                      }, "No results found. Please search again.", 8, _hoisted_26)
                    ]))
                  : (!_ctx.loadingContent && !_ctx.errorLoadingContent && _ctx.eeList.length > 0)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 4 }, _renderList(_ctx.eeListDisplay, (ee) => {
                        return (_openBlock(), _createElementBlock("tr", null, [
                          _createElementVNode("td", _hoisted_27, _toDisplayString(ee.lawId), 1),
                          _createElementVNode("td", _hoisted_28, _toDisplayString(ee.email), 1),
                          _createElementVNode("td", _hoisted_29, _toDisplayString(ee.lastName), 1),
                          _createElementVNode("td", _hoisted_30, _toDisplayString(ee.firstName), 1),
                          _createElementVNode("td", {
                            "data-label": "Status",
                            class: _normalizeClass(ee.inactive ? 'inactive' : 'active')
                          }, _toDisplayString(ee.inactive ? 'Inactive' : 'Active'), 3),
                          _createElementVNode("td", _hoisted_31, [
                            _createElementVNode("button", {
                              class: "btn btn-default sml ml-2",
                              onClick: $event => (_ctx.gotoExternalExaminerDashboard(ee.id))
                            }, "View", 8, _hoisted_32)
                          ])
                        ]))
                      }), 256))
                    : _createCommentVNode("", true)
        ])
      ])
    ]),
    (_ctx.showAddEEModal)
      ? (_openBlock(), _createBlock(_component_AddEeModal, {
          key: 0,
          onCloseEEModal: _cache[3] || (_cache[3] = $event => (_ctx.showAddEEModal = false))
        }))
      : _createCommentVNode("", true)
  ]))
}